import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

export default function Sidebar(props) {
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  const items = [
    {
      pathname: "/dashboard",
      title: "My Animations",
      icon: "fa-video",
    },
    {
      pathname: "/sessions",
      title: "My Sessions",
      icon: "fa-calendar",
    },
    {
      pathname: "/edit",
      title: "AI Editor",
      icon: "fa-edit",
    },
    {
      pathname: "/history",
      title: "My History",
      icon: "fa-tasks",
    },
    {
      pathname: "/profile",
      title: "Settings",
      icon: "fa-cog",
    },
    {
      pathname: "/contact",
      title: "Contact",
      icon: "fa-user-friends",
    },
  ];

  const adminItems = [
    {
      pathname: "/admin/recent-reservations",
      title: "Reservations",
      icon: "fa-history",
    },
    {
      pathname: "/admin/active-sessions",
      title: "Active Sessions",
      icon: "fa-spinner",
    },
    {
      pathname: "/admin/users",
      title: "User Manager",
      icon: "fa-user-cog",
    },
    {
      pathname: "/admin/maintenance",
      title: "Maintenance",
      icon: "fa-tools",
    },
    {
      pathname: "/admin/user-list",
      title: "User List",
      icon: "fa-user-friends",
    },
  ]

  return (
    <>
      <div className={props.showmenu ? "left-navbar left-navbar-show" : "left-navbar"}  >
        <ul className="navbar-items d-flex flex-column align-items-center list-unstyled">
          { items.map((item, index) => (
            <li key={index} className={`navbar-item ${location.pathname === item.pathname ? "active" : ""}`}>
              <Link to={item.pathname} title={item.title}>
                <i className={"fa text-white " + item.icon}></i>
              </Link>
            </li>
          ))}
          { (auth.userDeatils?.is_admin || auth.userDeatils?.is_staff) && (
            <>
              <li className="navbar-sep"></li>
              { adminItems.map((item, index) => (
                <li key={index} className={`navbar-item ${location.pathname === item.pathname ? "active" : ""}`}>
                  <Link to={item.pathname} title={item.title}>
                    <i className={"fa text-white " + item.icon}></i>
                  </Link>
                </li>
              ))}
            </>
          )}
        </ul>
      </div>
    </>
  );
}
